import Action from 'redux/helpers/createAction'
const name = 'domainsList'

export const loadDomains = Action(name + '/LOAD_DOMAINS')

export const loadDomainsSuccess = Action(name + '/LOAD_DOMAINS_SUCCESS', domains => ({
  domains
}))

export const loadDomainsFailure = Action(name + '/LOAD_DOMAINS_FAILURE', error => ({
  error
}))

export const loadDomainOverview = Action(name + '/GET_DOMAIN_OVERVIEW', id => ({
  id
}))

export const loadDomainOverviewSuccess = Action(
  name + '/GET_DOMAIN_OVERVIEW_SUCCESS',
  (id, overview) => ({
    id,
    overview
  })
)

export const loadDomainsFully = Action(name + '/LOAD_DOMAINS_FULLY', filters => ({
  filters
}))

export const loadDomainsFullySuccess = Action(name + '/LOAD_DOMAINS_FULLY_SUCCESS', domains => ({
  domains
}))

export const loadDomainsFullyFailure = Action(name + '/LOAD_DOMAINS_FULLY_FAILURE', error => ({
  error
}))

export const sortDomains = Action(name + '/SORT_DOMAINS', (value, order) => ({
  value,
  order
}))

export const deleteDomain = Action(name + '/DELETE_DOMAIN', domainId => ({
  domainId
}))

export const deleteDomainSuccess = Action(name + '/DELETE_DOMAIN_SUCCESS', domainId => ({
  domainId
}))

export const deleteDomainFailure = Action(name + '/DELETE_DOMAIN_FAILURE', error => ({
  error
}))

export const editDomain = Action(name + '/EDIT_DOMAIN_REDIRECT', domainId => ({
  domainId
}))

export const addKeywords = Action(name + '/ADD_KEYWORDS_REDIRECT', domainId => ({
  domainId
}))

export const addCompetitors = Action(name + '/ADD_COMPETITORS_REDIRECT', domainId => ({
  domainId
}))
